import React from "react";

/**
 * Ornamental sunflower SVG - a subtle nod to Arya's love for sunflowers.
 * Use low opacity for background/lateral decoration.
 */
export function SunflowerOrnament({ size = 200, className = "", opacity = 0.14 }) {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      className={className}
      style={{ opacity }}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="sun-center" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#7B5615"/>
          <stop offset="100%" stopColor="#3A2A0A"/>
        </radialGradient>
      </defs>
      {/* Outer decorative circle */}
      <circle cx="100" cy="100" r="94" fill="none" stroke="#C79A3A" strokeWidth="0.6" strokeDasharray="1 6"/>
      <circle cx="100" cy="100" r="82" fill="none" stroke="#C79A3A" strokeWidth="0.4"/>
      {/* 20 petals */}
      {Array.from({ length: 20 }).map((_, i) => {
        const angle = (i * 360) / 20;
        return (
          <g key={i} transform={`rotate(${angle} 100 100)`}>
            <path
              d="M100 22 C 108 46, 108 62, 100 78 C 92 62, 92 46, 100 22 Z"
              fill="#E9CC85"
              stroke="#C79A3A"
              strokeWidth="0.6"
            />
          </g>
        );
      })}
      {/* Inner petals layer */}
      {Array.from({ length: 20 }).map((_, i) => {
        const angle = (i * 360) / 20 + 9;
        return (
          <g key={"i" + i} transform={`rotate(${angle} 100 100)`}>
            <path
              d="M100 40 C 105 58, 105 68, 100 78 C 95 68, 95 58, 100 40 Z"
              fill="#C79A3A"
              opacity="0.55"
            />
          </g>
        );
      })}
      {/* Center */}
      <circle cx="100" cy="100" r="22" fill="url(#sun-center)"/>
      <circle cx="100" cy="100" r="16" fill="none" stroke="#F5EBD7" strokeWidth="0.4"/>
      {/* seeds pattern */}
      {Array.from({ length: 12 }).map((_, i) => {
        const angle = (i * 360) / 12;
        const rad = (angle * Math.PI) / 180;
        const x = 100 + Math.cos(rad) * 10;
        const y = 100 + Math.sin(rad) * 10;
        return <circle key={"s" + i} cx={x} cy={y} r="1.2" fill="#F5EBD7" opacity="0.7"/>;
      })}
    </svg>
  );
}

/** Tiny inline sunflower for section dividers and small accents. */
export function SunflowerMini({ size = 18, className = "" }) {
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} className={className} aria-hidden="true">
      {Array.from({ length: 12 }).map((_, i) => (
        <g key={i} transform={`rotate(${(i * 360) / 12} 20 20)`}>
          <ellipse cx="20" cy="7" rx="2.2" ry="6" fill="currentColor"/>
        </g>
      ))}
      <circle cx="20" cy="20" r="5" fill="#7B5615"/>
    </svg>
  );
}
